jQuery(document).ready(function($) {

    // Handle multiple FAQ blocks independently
    $('.faq-wrapper').each(function() {

        let wrapper = $(this);

        wrapper.find('.faq-question').on('click', function() {

            let target = $(this).data('target');
            let answer = wrapper.find(target);
            let symbol = $(this).find('.faq-toggle-symbol');

            answer.slideToggle(200);

            // Toggle symbol
            symbol.text(symbol.text() === '+' ? '-' : '+');
        });

    });

});